<script setup lang="ts">
import globalHeader from '@/layouts/imports/header.vue'
import globalFooter from '@/layouts/imports/footer.vue'

import type { NuxtError } from '#app'

useHead({
  title: 'Error'
})

defineProps({
  error: Object as () => NuxtError
})

definePageMeta({
  layout: 'empty'
})

const { isLoggedIn } = useUserStore()

const pageNotFound = '404 Not Found'

//const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <v-app>
    <global-header />

    <v-main>
      <v-container container--fluid>
        <v-row justify="center" class="no-border">
          <v-col cols="auto">
            <div class="text-center">
              <h3 v-if="error?.statusCode === 404">
                <div v-if="isLoggedIn()">
                  {{ pageNotFound }}
                </div>
                <div v-else>401 UNAUTHORIZED</div>
              </h3>
              <h3 v-else>{{ error?.statusCode }} Error</h3>

              <br />

              <div v-if="error?.statusCode === 404">
                <div v-if="isLoggedIn()">This page could not be found.</div>
                <div v-else>Please login.</div>
              </div>
              <div v-else-if="error?.statusCode === 503">
                {{ error?.message }}
                <p>Please try again later.</p>
              </div>
              <div v-else>{{ error?.message }}</div>

              <br />

              <v-btn color="primary" outline @click="navigateTo('/')" variant="outlined">Home page</v-btn>
              <!-- <NuxtLink to="/" color="primary"> Home page </NuxtLink> -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <global-footer />
  </v-app>
</template>
